import { React, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import firebase from "../../node_modules/firebase/compat/app"
import { getAuth, signInWithEmailAndPassword, updatePassword } from "firebase/auth";
import { collection, setDoc, addDoc, getDoc, doc } from "firebase/firestore";
import { firebaseConfig } from "../firebase-config";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Sidebar from './components/sidebar'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import InstantMessage from './InstantMessage.js';
import { createTheme, responsiveFontSizes } from '@mui/material';
import { ThemeProvider } from '@emotion/react';

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();

function ChangePassword() {
    const auth = getAuth();
    const user = auth.currentUser;

    const [OldPassword, setoldPassword] = useState("");
    const [loginPassword, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [OldPasswordError, NewOldPasswordError] = useState(false);
    const [PasswordError, NewPasswordError] = useState(false);
    const [ConfirmPasswordError, NewConfirmPasswordError] = useState(false);

    const [instant, setInstant] = useState(false); // Controls Alert
    const [severity, setSeverity] = useState(''); // Controls Severity
    const [message, setMessage] = useState('') // Controls Message

    const [OldPasswordHT, NewOldPasswordHT] = useState("");
    const [PasswordHT, NewPasswordHT] = useState("");
    const [ConfirmPasswordHT, NewConfirmPasswordHT] = useState("");

    const [disabledConfirm, setDisabledConfirm] = useState(true)

    let navigate = useNavigate();

    const changePass = async (user, oldPassword, newPassword) => {

      var email = user.email
      var password = oldPassword

      signInWithEmailAndPassword(auth, email, password)
      .then((userCredential)=>{
        updatePassword(user,newPassword)
        setInstant(true); 
        setSeverity("success")
        setMessage('Password changed.')
        // navigate("/dashboard")
      })
      .catch((error)=>{
        console.log(error)
        console.log("change password failed")
        setInstant(true)
        setSeverity("error")
        setMessage('Change password failed. Please try again.')
      })
        // updatePassword(user,newPassword).then(()=>{
        // console.log("password changed")
        // setInstant(true); 
        // setMessage('Password changed.')
        // }).catch((error)=>{
        // console.log(error)
        // console.log("change password failed")
        // setMessage('Change password failed.')
        // })
    }

    // for chase:
    // di need ung useEffect
    // just use yung function na changePass with parameters `user` and `password` to change the `user`'s password
    // naka-store sa `user` yung current user, to get ung email ng user, use `user.email`
    // `password` should come from textbox field

    return(
      <ThemeProvider theme={theme}>
        <Box>
        <Sidebar /> 
        <Box style={{ display:'flex', justifyContent:'center'}}>
          <Grid sx={{mx:5, my:20}}>
            <Card sx={{boxShadow:5, mb:3}} style={{ maxWidth: 600, padding: "10px 5px", margin: "0 auto", justifyContent:'center' }}>
              <CardContent>
                {instant ?  <InstantMessage sev = {severity} message = {message} /> : `` }
                <Typography align = "center" fontWeight="bold" component="h1" variant="h5" sx={{ mt: 3, mb:5 }} fontFamily="Segoe UI" >
                  CHANGE ACCOUNT PASSWORD
                </Typography>
                <form>
                  <Grid container spacing={1}>

                    <Grid item xs={12}>
                      <TextField type="password" placeholder="Enter your old password" label="Old Password" variant="outlined" helperText = {OldPasswordHT} fullWidth required 
                      onChange={(event) => {
                        setInstant(false); 
                        setoldPassword(event.target.value);
                        if (event.target.value === "" || event.target.value.length < 8){
                          NewOldPasswordHT("Password must be at least 8 characters.");
                          NewOldPasswordError(true);
                        }
                        else{
                          NewOldPasswordHT("")
                          NewOldPasswordError(false);
                        }
                      }}
                      error = {OldPasswordError}
                      />
                    </Grid>


                    <Grid item xs={12}>
                      <TextField type="password" placeholder="Enter your password" label="Password" variant="outlined" helperText = {PasswordHT} fullWidth required 
                      onChange={(event) => {
                        setConfirmPassword("")
                        setInstant(false); 
                        setPassword(event.target.value);
                        if (event.target.value === "" || event.target.value.length < 8){
                          NewPasswordHT("Password must be at least 8 characters.");
                          NewPasswordError(true);
                          setDisabledConfirm(true);
                        }
                        else{
                          NewPasswordHT("")
                          NewPasswordError(false);
                          setDisabledConfirm(false);
                        }
                      }}
                      error = {PasswordError}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField type="password" value={confirmPassword} disabled={disabledConfirm} placeholder="Re-enter your password" label="Confirm Password" variant="outlined" helperText = {ConfirmPasswordHT} fullWidth required 
                      onChange={(event) => {
                        setInstant(false); 
                        setConfirmPassword(event.target.value);
                        if (event.target.value !== loginPassword){
                          NewConfirmPasswordHT("Password does not match.");
                          NewConfirmPasswordError(true);
                        }
                        else{
                          NewConfirmPasswordHT("")
                          NewConfirmPasswordError(false);
                        }
                      }}
                      error = {ConfirmPasswordError}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Button type="submit" variant="contained" style={{fontFamily: "Segoe UI"}} sx={{ mt:1, mb:2, bgcolor: '#7B1113', ":hover": {bgcolor: "#5A0C0E", color: 'white'}}} fullWidth
                      onClick={e => {
                        e.preventDefault()
                        if(OldPassword && loginPassword && confirmPassword && !(PasswordError || ConfirmPasswordError || OldPasswordError)){
                           changePass(user,OldPassword,loginPassword)
                        }
                        else{
                          setMessage("Please enter a valid password.")
                          setInstant(true); 
                          if (OldPassword === ""){
                            NewOldPasswordHT("Enter your old password");
                            NewOldPasswordError(true);
                          }
                          if (loginPassword === ""){
                            NewPasswordHT("Enter a password");
                            NewPasswordError(true);
                          }
                          if (confirmPassword === ""){
                            NewPasswordHT("Re-enter your password");
                            NewPasswordError(true);
                          }
                        }
                      }}
                      >
                      Submit
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Box>  
        </Box>
    </ThemeProvider>
    )
}

export default ChangePassword